export default __webpack_public_path__ + "static/media/LENS_CULINARIS_TEKAY_complete_5.21a0bbaa.jpg";